export default { sha: '936d0223a9084b1eab3348ecd26485889929b64b', buildNumber: 'undefined' }
